
import React, { useState, useContext, useEffect } from 'react';
import {IProps} from './types';
import C from '@assets/themes/colors';
import { Layer, Rect, Text, Group } from 'react-konva';
import Konva from 'konva';


const NoArtboardCanvasElement: React.FC<IProps> = (props) => {
  
  const groupRef = React.useRef() as React.MutableRefObject<Konva.Group>;    
  
  useEffect(() => {
    if (props.exporting)
      DownloadNoArtboard()  
  }, [props.exporting]);

  useEffect(() => {
    if (props.savingParsedTree && props.showSelectDescribe === false)
    {
      setTimeout(() =>{
        let name = props.exportingProperties?.designName.replace(' ','_');      
        let data = GeneratePreview()        
        props.savingPreview(data,name)
      },500)
     
    }

  }, [props.savingParsedTree])

  const DownloadNoArtboard=()=>
  {
    let file_name = props.exportingProperties?.designName.replace(' ','_')+'.'+props.exportingProperties?.format.toLowerCase();           
    let quality =100;
      if (props.exportingSizes && props.exportingProperties?.compressFiles)
    {          
      let expratio = props.exportingSizes[0]
      quality = expratio && expratio.ratio? expratio.ratio:100;        
    }
      let format = (props.exportingProperties && props.exportingProperties.format)?props.exportingProperties.format.toLocaleLowerCase():""
      let dataURL = GetDataUrl(quality,format)
      if (dataURL)
        downloadURI(dataURL, file_name);               
  }
  const GeneratePreview=()=>{
    let quality =props.previewConfig.quality;
    let scale = props.previewConfig.scale;
    let b64Data = GetDataUrl(quality,props.previewConfig.format)
    if (b64Data)
    {
      b64Data = b64Data.replace("data:image/png;base64,","");
      b64Data = b64Data.replace("data:image/jpeg;base64,","");
    }
    return b64Data
  }
  const GetDataUrl= (quality:number, format:string) =>
  { 
    if (groupRef && groupRef.current)
    {
      quality= quality/100             
      return groupRef.current.toDataURL({quality:quality, mimeType:"image/"+format, pixelRatio: 1 });
    }

  }




  const GetDefaultSize=() =>
  {
    let found =false;
    let quality = 100;
    let fileSize;
    let i =0;
    let minquality=0;
    let maxquality=100;    
    do{
      


      quality = Math.round(minquality + ((maxquality-minquality)/2));
      
      let dataURL = GetDataUrl(quality,"jpeg");            
      fileSize = getFileSize(dataURL)      
      if (fileSize>= (props.exportingValues?props.exportingValues.defaultMinSize:0) && fileSize<= (props.exportingValues?props.exportingValues.defaultMaxSize:0))
        found = true;
      else
      { 
        if (fileSize< (props.exportingValues?props.exportingValues.defaultMinSize:0))
        {
          if (quality==minquality)
            minquality = maxquality
          else
            minquality = quality;          

        }
        else
        {
          if (quality== maxquality)
            maxquality = minquality
          else
            maxquality = quality;        

        }        
        if (quality>100 || quality<=0 || (quality == maxquality && quality==minquality ))         
          found = true;
      }
      i++;
      if (i===100)
      {
        found =true;
      }
    }while(!found)
    
    props.onExportingCompress(fileSize,quality)



  }

  
  useEffect(() => {

      if (props.exportingProperties && props.exportingProperties.compressRatios)
      {
        if (props.exportingProperties?.compressArtboard===undefined)
          SetNoArboardSize()
      }              
  },[props.exportingProperties?.compressRatios]);
  
  const SetNoArboardSize=()=>
  {
    let quality =-1;

    if (props.exportingProperties && props.exportingProperties.compressRatios)
    {
      let expratio = props.exportingProperties.compressRatios[0]
      quality = (expratio && expratio.ratio)? expratio.ratio:-1;        
    }
    let format = (props.exportingProperties && props.exportingProperties.format)?props.exportingProperties.format.toLocaleLowerCase():""          
    if (quality>=0)
    {
      let dataURL = GetDataUrl(quality, format);
      if (dataURL)
      {                
        let fileSize = getFileSize(dataURL)          
        props.onExportingCompress(fileSize,quality)                   
      }
    }
    else
    {
        GetDefaultSize();
    }
  }


  const getFileSize= (b64Data:any) =>  {
    
    b64Data = b64Data.replace("data:image/png;base64,","");
    b64Data = b64Data.replace("data:image/jpeg;base64,","");
    let sizeInBytes = 4 * Math.ceil((b64Data.length / 3)) * 0.5624896334383812;
    return sizeInBytes;
  }

  
  function downloadURI(dataURL:any, name:any) {

    dataURL = dataURL.substring(dataURL[0].indexOf(',') + 1);

    var link = document.createElement('a');
    link.download = name;
    link.href = dataURL;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  
  return (
    <>     
      <Group                        
        ref={groupRef}
      >                    
        {props.children}
      </Group>
    </>
  );
}

export default NoArtboardCanvasElement;